import React from 'react';

export default function OurStory() {

  return(
    <section className='about-main-container'>
      <h2>Coming Soon!</h2>
    </section>
  )
}